import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity, updateEntity, createEntity, reset } from './par-type-prise-en-charge.reducer'; // Assurez-vous que le chemin est correct
import { IParTypePriseEnCharge } from 'app/shared/model/par-type-prise-en-charge.model'; // Assurez-vous que le chemin est correct
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/status.model';
import { getEntities as getMetCategories } from 'app/entities/met-category/met-category.reducer'; // Assurez-vous que le chemin est correct

export const ParTypePriseEnChargeUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const parTypePriseEnChargeEntity = useAppSelector(state => state.parTypePriseEnCharge.entity);
  const loading = useAppSelector(state => state.parTypePriseEnCharge.loading);
  const updating = useAppSelector(state => state.parTypePriseEnCharge.updating);
  const updateSuccess = useAppSelector(state => state.parTypePriseEnCharge.updateSuccess);
  const statusValues = Object.keys(Status);
  const metCategories = useAppSelector(state => state.metCategory.entities);

  const handleClose = () => {
    props.history.push('/par-type-prise-en-charge');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
    dispatch(getMetCategories({}));
  }, [dispatch, props.match.params.id, isNew]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess, handleClose]);

  const saveEntity = values => {
    const entity = {
      ...parTypePriseEnChargeEntity,
      ...values,
      category: metCategories.find(it => it.id.toString() === values.category.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? { status: 'ACTIVE' } // Valeur par défaut pour un nouvel enregistrement
      : {
          status: parTypePriseEnChargeEntity.status,
          ...parTypePriseEnChargeEntity,
          category: parTypePriseEnChargeEntity?.category?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="almobadaraMasterDataApp.parTypePriseEnCharge.home.createOrEditLabel" data-cy="ParTypePriseEnChargeCreateUpdateHeading">
            <Translate contentKey="almobadaraMasterDataApp.parTypePriseEnCharge.home.createOrEditLabel">
              Create or edit a ParTypePriseEnCharge
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="par-type-prise-en-charge-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypePriseEnCharge.name')}
                id="par-type-prise-en-charge-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypePriseEnCharge.nameAr')}
                id="par-type-prise-en-charge-nameAr"
                name="nameAr"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypePriseEnCharge.nameEn')}
                id="par-type-prise-en-charge-nameEn"
                name="nameEn"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.parTypePriseEnCharge.status')}
                id="par-type-prise-en-charge-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {statusValues.map(status => (
                  <option value={status} key={status}>
                    {translate('almobadaraMasterDataApp.Status.' + status)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="par-type-prise-en-charge-category"
                name="category"
                data-cy="category"
                label={translate('almobadaraMasterDataApp.parTypePriseEnCharge.category')}
                type="select"
              >
                <option value="" key="0" />
                {metCategories
                  ? metCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/par-type-prise-en-charge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParTypePriseEnChargeUpdate;
